export default class EditChildrenExecutionCtrl {
  constructor ($scope, $mdDialog, ReviewSrv, WorkPlanModalSrv, $state, $cookies, WorkPlanSrv, ngNotify,
      Validations, Ramda, activity) {

    const currentModule = $state.current.module

    angular.extend($scope, {
      regUpdate: regUpdate,
      upCompare: upCompare,
      inTeaching: Validations.inTeaching(currentModule),
      close: close
    })

    activate()

    function activate () {
      $scope.saving = false
      history(activity.children)
      if (activity.children.itemRequired || activity.itemRequired > 0) $scope.min = 1
    }

    function regUpdate (reg, i) {

      $scope.saving = true
      if ($scope.arrayvar[i].num_hours_executed != reg.num_hours_executed) {
        $scope.diff = reg.num_hours_executed - $scope.arrayvar[i].num_hours_executed
      } else {
        $scope.diff = 0
      }
      let params = {
        id_key: activity.children.workplanTeacherActivityId,
        hourdiff: $scope.diff,
        id_code: reg.id_code,
        num_hours_executed: reg.num_hours_executed,
        ds_description: reg.ds_description
      }

      if (!$scope.inTeaching) {

        params.dt_start_date = moment(reg.dt_start_date).format('YYYY-MM-DD')
        params.dt_end_date   = moment(reg.dt_end_date).format('YYYY-MM-DD')
      }

      WorkPlanSrv.postUptHistoryActivities.get(params).$promise.then((response) => {
        if (!response.status) {
          ngNotify.set('Error al conectar con el servicio', 'error')
        } else {
          activity.children.hoursExecuted += $scope.diff
          //ngNotify.set('Bitacora Actualizada', 'success')
          $scope.close()
        }
      }, (err) => {
        ngNotify.set('Imposible conectar con el servicio', 'error')
      })
      
    }

    function close () {
      return $mdDialog.hide()
    }

    function history (activity) {
      let params = {
        id: activity.workplanTeacherActivityId
      }
      WorkPlanSrv.getHistoryActivities.get(params).$promise.then((response) => {
        if (!response.status) {
          ngNotify.set('Error al conectar con el servicio', 'error')
        } else {
          $scope.variable = response.data
          $scope.arrayvar = angular.copy(response.data)
          for (var i = $scope.variable.length - 1; i >= 0; i--) {
            $scope.variable[i].dt_start_date = moment($scope.variable[i].dt_start_date, 'DD-MM-YYYY').toDate()
            $scope.variable[i].dt_end_date = moment($scope.variable[i].dt_end_date, 'DD-MM-YYYY').toDate()
            
          }
        }
      }, (err) => {
        ngNotify.set('Imposible conectar con el servicio', 'error')
      })
    }

    function upCompare (reg, i) {
      if ($scope.arrayvar[i].ds_description != reg.ds_description || 
          $scope.arrayvar[i].num_hours_executed != reg.num_hours_executed || 
          $scope.arrayvar[i].dt_start_date != reg.dt_start_date ||
          $scope.arrayvar[i].dt_end_date != reg.dt_end_date) {
        return false
      } else {
        return true
      }
    }
  }
}

EditChildrenExecutionCtrl.$inject = ['$scope', '$mdDialog', 'ReviewSrv', 'WorkPlanModalSrv', '$state', '$cookies',
  'WorkPlanSrv', 'ngNotify', 'Validations', 'Ramda', 'activity']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/modals/editChildrenExecutionCtrl.js